import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ThumbnailSlider.css';
import { faLiraSign } from '@fortawesome/free-solid-svg-icons';

const ThumbnailSlider = ({ imageUrls, setSelectedImagesp }) => {
    const [selectedImages, setSelectedImages] = useState([]);
    const customerId = localStorage.getItem("customerId")

    function getpictureurl(url) {
        let finalUrl = "";
        let urlreturn = "";
        if ((url.split(".").includes("png"))) {
          urlreturn = `${window.location.origin}/api/v1/gcp-asset-file?username=${customerId}&filePath=` + url;
    
        }else{
            urlreturn=url
        }
        return urlreturn;
      }


    useEffect(() => {
        if (selectedImages.length > 0) {
            setSelectedImagesp(selectedImages)
        }
    }, [selectedImages, setSelectedImagesp])

    if (!imageUrls || imageUrls.length === 0) {
        return <div>No images to display</div>;
    }

    const handleCheckboxChange = (url) => {
        setSelectedImages((prevSelectedImages) => {
            if (prevSelectedImages.includes(url)) {
                return prevSelectedImages.filter((image) => image !== url);
            } else {
                return [...prevSelectedImages, url];
            }
        });
        console.log(`Selected images: ${selectedImages}`); // Add this line
    };

    console.log(handleCheckboxChange);

    const thumbnails = imageUrls.map((url, index) => (
        <div key={index} className="thumbnail-container">
            <img
                src={getpictureurl(url)}
                alt={`Thumbnail ${index}`}
                className="custom-thumbnail"
            />
            <div className="checkbox-container">
                <label>
                    <input
                        type="checkbox"
                        checked={selectedImages.includes(url)}
                        onChange={() => handleCheckboxChange(url)}
                    />

                </label>
            </div>
            <p>Page No:- {index+1}</p>

        </div>
    ));

    const sliderSettings = {

        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: false
    };

    return (
        <div>
            <div className="thumbnails-wrapper">
                {thumbnails}
            </div>
            {selectedImages.length > 0 && (
                <Slider {...sliderSettings} className="custom-thumbnail-slider">
                    {selectedImages.map((image, index) => (
                        // const match = url.match(/converted\.(\d+)\.png/);

                        <div key={index} className="slider-image-container">
                           
                            <img
                                src={getpictureurl(image)}
                                alt={`Selected ${index}`}
                                className="slider-image"
                            />
                             {(() => {
                                const match = image.match(/converted\.(\d+)\.png/);
                                const pageNumber = match ? match[1] : "No match found";
                                return <p>Page No: {pageNumber}</p>;
                            })()}
                        </div>
                    ))}
                </Slider>
            )}
        </div>
    );
};

export default ThumbnailSlider;